var _class, _descriptor, _descriptor2, _descriptor3;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import TerriaError from "../../Core/TerriaError";
import Button from "../../Styled/Button";
import { scrollBars } from "../../Styled/mixins";
import { useViewState } from "../Context";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import Loader from "../Loader";
import WarningBox from "../Preview/WarningBox";
import ParameterEditor from "./ParameterEditor";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class FunctionViewModel {
  constructor(catalogFunction) {
    _defineProperty(this, "catalogFunction", void 0);
    _defineProperty(this, "_parameters", {});
    this.catalogFunction = catalogFunction;
    this._parameters = {};
  }
  getParameter(parameter) {
    let result = this._parameters[parameter.id];
    if (!result || result.parameter !== parameter) {
      result = this._parameters[parameter.id] = new ParameterViewModel(parameter);
    }
    return result;
  }
  validateParameter(parameter) {
    if (!parameter.isValid || !this.getParameter(parameter).isValueValid) {
      // Editor says it's not valid, so it's not valid.
      return false;
    }

    // Verify that required parameters have a value.
    if (parameter.isRequired && (parameter.value === undefined || parameter.value === null)) {
      return false;
    }
    return true;
  }
}
let ParameterViewModel = (_class = class ParameterViewModel {
  constructor(parameter) {
    _defineProperty(this, "parameter", void 0);
    _initializerDefineProperty(this, "userValue", _descriptor, this);
    _initializerDefineProperty(this, "isValueValid", _descriptor2, this);
    _initializerDefineProperty(this, "wasEverBlurredWhileInvalid", _descriptor3, this);
    makeObservable(this);
    this.parameter = parameter;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isValueValid", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "wasEverBlurredWhileInvalid", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
const InvokeFunction = observer(_ref => {
  var _previewed$loadMetada, _previewed$loadMetada2;
  let {
    previewed
  } = _ref;
  const viewState = useViewState();
  const [t] = useTranslation();
  let functionParameters, parametersError;
  try {
    functionParameters = previewed.functionParameters;
  } catch (e) {
    // .functionParameters might throw an error. Handle it here.
    parametersError = TerriaError.from(e);
  }
  const error = (_previewed$loadMetada = (_previewed$loadMetada2 = previewed.loadMetadataResult) === null || _previewed$loadMetada2 === void 0 ? void 0 : _previewed$loadMetada2.error) !== null && _previewed$loadMetada !== void 0 ? _previewed$loadMetada : parametersError;
  const description = previewed.description ? parseCustomMarkdownToReact(previewed.description, {
    catalogItem: previewed
  }) : undefined;
  const functionViewModel = useMemo(() => new FunctionViewModel(previewed), [previewed]);
  const invalidParameters = !functionParameters || functionParameters.some(param => functionViewModel.validateParameter(param) !== true);
  const runAnalysis = () => {
    previewed.submitJob().catch(e => {
      viewState.terria.raiseErrorToUser(e);
    });
    runInAction(() => {
      // Close modal window
      viewState.explorerPanelIsVisible = false;
      // mobile switch to nowvewing
      viewState.switchMobileView(viewState.mobileViewOptions.preview);
    });
  };
  if (previewed.isLoading) {
    return /*#__PURE__*/_jsx(Loader, {});
  }
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx("h3", {
        children: previewed.name
      }), error && /*#__PURE__*/_jsx(WarningBox, {
        error: error,
        viewState: viewState
      }), description && /*#__PURE__*/_jsx("div", {
        children: description
      }), /*#__PURE__*/_jsx("div", {
        children: functionParameters && functionParameters.map(param => /*#__PURE__*/_jsx(ParameterEditor, {
          parameter: param,
          viewState: viewState,
          previewed: previewed,
          parameterViewModel: functionViewModel.getParameter(param)
        }, param.id + previewed.uniqueId))
      })]
    }), /*#__PURE__*/_jsx(Footer, {
      children: /*#__PURE__*/_jsx(Button, {
        primary: true,
        fullWidth: true,
        disabled: invalidParameters,
        onClick: runAnalysis,
        children: t("analytics.runAnalysis")
      })
    })]
  });
});
const Wrapper = styled.div.withConfig({
  displayName: "InvokeFunction__Wrapper",
  componentId: "sc-lcbb1p-0"
})(["display:flex;flex-direction:column;padding:", ";position:relative;height:calc(100% - ", " * 2);a{color:variables.$color-primary;}"], p => p.theme.paddingSmall, p => p.theme.paddingSmall);
const Content = styled.div.withConfig({
  displayName: "InvokeFunction__Content",
  componentId: "sc-lcbb1p-1"
})(["", " overflow-y:auto;height:calc(100% - ", ");padding-right:", ";padding-left:", ";h3{margin-top:0;}"], p => scrollBars(p), p => p.theme.inputHeight, p => p.theme.padding, p => p.theme.padding);
const Footer = styled.div.withConfig({
  displayName: "InvokeFunction__Footer",
  componentId: "sc-lcbb1p-2"
})(["background:", ";padding:", ";"], p => p.theme.modalBg, p => p.theme.paddingSmall);
export default InvokeFunction;